module.exports = __webpack_public_path__ + "img/ivdNt-logo-small.ecb4c292.svg";